import { Module } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import PaymentState from '../../types/PaymentState'
import rootStore from '@vue-storefront/core/store'

export const paymentModule: Module<PaymentState, RootState> = {
  namespaced: true,
  state: {
    methods: []
  },
  mutations: {
    addMethod (state, paymentMethod) {
      state.methods.push(paymentMethod)
    },
    replaceMethods (state, paymentMethods) {
      state.methods = paymentMethods
    }
  },
  actions: {
    addMethod ({commit}, paymentMethod) {
      commit('addMethod', paymentMethod)
    },
    replaceMethods ({commit}, paymentMethods) {
      commit('replaceMethods', paymentMethods)
    }
  },
  getters: {
    paymentMethods (state) {
      const device = rootStore.getters['user/getDevice']
      return state.methods.filter(method => {
        if (device !== 'iphone' && method.code === 'ipay_applepay') {
          return false
        }
        return method
      })
    },
    allPaymentMethods: state => state.methods
  }
}
